import router from "@/router";
import store from "@/store";
import { AREAS_ICONS, AREAS_SUBTITLES, AREAS_COLOR_ICONS } from './constants';
/**
 * Normalize user data before it is sent to API to register a new user.
 * @param {*} data
 */
function normalizeUserData(data) {
  var userData = { user: data };
  return userData;
}

/**
 * Builds the value of the header 'Authorization' to be passed on requests
 * to API.
 */
function getAuthorizationToken() {
  return `Bearer ${window.localStorage.getItem("authToken")}`;
}

/**
 * Return the amount (without decimals) of a plan, from the store state.
 * @param {*} plansByName
 * @param {*} planName
 */
function getPlanAmountFromState(plansByName, planName) {
  if (plansByName[planName] && plansByName[planName]["amount"]) {
    return Math.round(plansByName[planName]["amount"]);
  }
  return null;
}
function chartData(verificationData, names, barData, max, format) {
  if (verificationData) {
    return {
      grid: {
        containLabel: true,
        left: '8%',
        bottom: '8%',
        right: '8%',
        top: '8%',
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "shadow",
        },
      },
      xAxis: {
        triggerEvent: true,
        data: names,
        axisLabel: {
          fontSize: "7px",
          color: "black",
          interval: 0,
        },
      },
      yAxis: {
        type: "value",
        max: max,
        minInterval: 1,
        axisLine: { show: false },
        axisLabel: { show: false },
        axisTick: { show: false },
        splitLine: { show: false }
      },
      series: [
        {
          type: "bar",
          barMaxWidth: 15,
          data: barData,
          label: {
            formatter: format ? '{c}%' : '{c}',
          },
        },

      ],
    };
  }
}

/**
 * Return the id of a plan, from the store state.
 * @param {*} plansByName
 * @param {*} planName
 */
function getPlanIdFromState(plansByName, planName) {
  if (plansByName[planName] && plansByName[planName]["id"]) {
    return plansByName[planName]["id"];
  }
  return null;
}

function getTakeSurveyPathByPresentationId(presentationId) {
  var path = router.resolve({
    name: "TakeSurvey",
    params: { id: presentationId },
  }).href;
  return window.location.origin + path;
}

function userIsLoggedIn() {
  if (store.state.currentUser) {
    return true;
  } else if (window.localStorage.getItem("currentUser")) {
    store.state.currentUser = JSON.parse(window.localStorage.currentUser);
    return true;
  }
  return false;
}

const tmScoresRangesInformation = [
  {
    text: "Urgent — ask for help",
    color: "#EE7A60",
    range: [0, 20],
  },
  {
    text: "Time to apply yourself",
    color: "#FFAF0F",
    range: [21, 40],
  },
  {
    text: "Ask for guidance",
    color: "#B5C0CB",

    range: [41, 60],
  },
  {
    text: "Almost there",
    color: "#3F9FEA",
    range: [61, 85],
  },
  {
    text: "Amazingly done!",
    color: "#00C7CE",
    range: [86, 100],
  },
];

function getTmScoreRangeInformationByValue(score) {
  const rangeFound = tmScoresRangesInformation.find(
    (range) => score >= range.range[0] && score <= range.range[1]
  );
  return rangeFound || { text: "", color: "" };
}

function tmScoresRangesInformationNames() {
  const names = tmScoresRangesInformation.map((element) => {
    return element.text;
  });
  return names || {};
}
function tmScoresRangesInformationColors() {
  const colors = tmScoresRangesInformation.map((element) => {
    return element.color;
  });
  return ["#000000", ...colors] || {};
}

function getAreaIconUrlByName(areaName) {
  return require("../../public/img/survey-results/" +
    AREAS_ICONS[areaName] +
    ".png");
}

function getAreaColorIconUrlByName(areaName) {
	return require('../../public/img/resources/' + AREAS_COLOR_ICONS[areaName] + '.png');
}

function normalizeQuestionsList (data = []) {
  let areas = {};
  let questions = [];
  let question_id = null;
  let area = null;
  let dataLength = data.length || 0;
  data.forEach((question, index) => {
    if (!(question.area in areas) && question.area in AREAS_ICONS) {
      areas[question.area] = {
        icon: AREAS_ICONS[question.area],
        subtitle: AREAS_SUBTITLES[question.area],
      }
    }
    if (question_id === null) question_id = question.id;
    if (area === null) area = question.area;
    if (!(question.area in questions)) questions[question.area] = {};
    if (!(question.id in questions[question.area])) {
      questions[question.area][question.id] = {
        question_id: question.id,
        question_category: question.topic,
        question_text: question.question_text,
        question_order: question.question_order,
        priority: question.importance,
        format: question.format === 0 ? 'online' : 'in person',
        score_accumulated: 0,
        total_responses: 0,
        averagePercentage: 0,
        value: '',
        color: '',
        answers: []
      }
    }
    questions[question.area][question.id].answers.push({
      answer_text: question.answer_text,
      score: question.score,
      count: question.count,
      ...filterAnswerRespondents(question.respondents),
    })
    questions[question.area][question.id].score_accumulated += question.score * question.count;
    if(question.score > 0) questions[question.area][question.id].total_responses += question.count;
    if ((question.id != question_id || ++index === dataLength) && question_id in questions[area]) {
      let score = 0;
      if (questions[area][question_id].total_responses > 0) {
        score = Math.floor(questions[area][question_id].score_accumulated / questions[area][question_id].total_responses);
      }
      const { text, color } = getTmScoreRangeInformationByValue(score);
      questions[area][question_id].averagePercentage = `${score}%`;
      questions[area][question_id].value = text;
      questions[area][question_id].color = color;
      question_id = question.id;
      area = question.area;
    }
  });
  return { questions, areas }
}

function filterAnswerRespondents(data = []){
  let anonCount = 0;
  const respondents = data.split(',');
  const filtered = [];

  respondents.forEach(element => {
    if(element !== 'Anonymous') filtered.push(element);
    else anonCount++;
  })

  return {
    anonCount: anonCount,
    respondents: filtered,
  }
}

function getQuestionsPriorityList(data = []){
  const priorityList =  [];
  for (let area in data){
    // convert object to array
    // sort array
    let questions = Object.values(data[area]);
    questions.sort((a, b) => Math.floor(b.score_accumulated / b.total_responses) - Math.floor(a.score_accumulated / a.total_responses));

    // criteria variables
    let importantQuestionsAbove86, regularQuestionsAbove86;

    // in person
    // check if important questions are all eg than 86%
    const highPriorityQuestions = filterQuestionsByPriority(questions, 'high');
    importantQuestionsAbove86 = checkQuestionsPctAbove(highPriorityQuestions, 86);

    if(importantQuestionsAbove86){
      // check if less important questions are all eg than 86%
      const lowPriorityQuestions = filterQuestionsByPriority(questions, 'low');
      regularQuestionsAbove86 = checkQuestionsPctAbove(lowPriorityQuestions, 86);
      if(regularQuestionsAbove86) {
        // if so, select the question high priority with the lower score
        const chosenQuestion = choosePriorityQuestion(highPriorityQuestions);
        if(chosenQuestion !== null) priorityList.push(chosenQuestion);
      }else{
        // select the one with lowest scroe from the low priority questions
        const chosenQuestion = choosePriorityQuestion(lowPriorityQuestions);
        if(chosenQuestion !== null) priorityList.push(chosenQuestion);
      }
    }else{
      const chosenQuestion = choosePriorityQuestion(highPriorityQuestions);
      if(chosenQuestion !== null) priorityList.push(chosenQuestion);
    }

    // select the online question with lowest score
    if(area === 'Connection'){
      const onlineQuestions = filterQuestionsByFormat(questions, 'online');
      if(onlineQuestions.length > 0){
        const chosenQuestion = choosePriorityQuestion(onlineQuestions);
        if(chosenQuestion !== null) priorityList.push(chosenQuestion);
      }
    }
  }
  return priorityList;
}

function choosePriorityQuestion(questions, pos = 0, refPos = null){
  const pct = Math.floor(questions[pos].score_accumulated / questions[pos].total_responses);
  if(pct === 0 && pos === 0) return null;
  if(pct === 0){
      if(refPos !== null){
          const last_pct = Math.floor(questions[pos - 1].score_accumulated / questions[pos - 1].total_responses);
          const ref_pct = Math.floor(questions[refPos].score_accumulated / questions[refPos].total_responses);
          if(ref_pct > last_pct) return questions[pos - 1].question_id;
          if(ref_pct === last_pct) return questions[refPos].question_id;
      }
      return questions[pos - 1].question_id;
  }
  if(pos + 1 < questions.length){
      const next_pct = Math.floor(questions[pos + 1].score_accumulated / questions[pos + 1].total_responses);
      if(pct > next_pct) return choosePriorityQuestion(questions, pos + 1, refPos);
      if(pct === next_pct && refPos === null) return choosePriorityQuestion(questions, pos + 1, pos);
      if(pct === next_pct && refPos !== null) {
          const ref_pct = Math.floor(questions[refPos].score_accumulated / questions[refPos].total_responses);
          if(pct < ref_pct) return choosePriorityQuestion(questions, pos + 1, pos);
          return choosePriorityQuestion(questions, pos + 1, refPos);
      }

  }
  if(pct > 0 && pos === questions.length - 1) {
      if(refPos !== null){
          const ref_pct = Math.floor(questions[refPos].score_accumulated / questions[refPos].total_responses);
          if(pct < ref_pct) return questions[pos].question_id;
          return questions[refPos].question_id
      }
      return questions[pos].question_id;
  }
}

function filterQuestionsByPriority(questions, priority){
  return questions.filter(question => question.priority === priority);
}

function filterQuestionsByFormat(questions, format){
  return questions.filter(question => question.format === format);
}

function checkQuestionsPctAbove(questions, pct) {
  return questions.every(question => 
    Math.floor(question.score_accumulated / question.total_responses) > pct
  );
}

function handleNewLine(str) {
  return str.replace(/(\\r)*\\n/g, "<br>");
}

function getLogoIconUrl() {
	return require('../../public/img/icons/black_icon.png');
}

function currencyFormatter() {
  var formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
  });
  return formatter;
}

const capitilizeWord = function(word) {
  return word.charAt(0).toUpperCase() + word.slice(1);
}

const changeToInitialCaps = function(word){
  const splitted = word.split(" ");
  const splittedCapitalized = splitted.map(string => capitilizeWord(string));
  return splittedCapitalized.join(" ");
}


const formatDate = function(value) {
  if(!value) return 'No date';
  return new Date(String(value))
    .toLocaleDateString('en-US', { 
      day: 'numeric', 
      month: 'short', 
      year: 'numeric', 
      timeZone: "UTC" 
    });
}


export {
  normalizeUserData,
  getAuthorizationToken,
  getPlanAmountFromState,
  getPlanIdFromState,
  getTakeSurveyPathByPresentationId,
  normalizeQuestionsList,
  getQuestionsPriorityList,
  getTmScoreRangeInformationByValue,
  getAreaIconUrlByName,
  userIsLoggedIn,
  handleNewLine,
  chartData,
  tmScoresRangesInformationNames,
  tmScoresRangesInformationColors,
  getLogoIconUrl,
  getAreaColorIconUrlByName,
  currencyFormatter,
  changeToInitialCaps,
  formatDate,
};
